export const GUEST_ORDER_AMOUNT_COLUMN_WIDTH = 160;
export const GUEST_ORDER_AMOUNT_COLUMN_SEPARATOR_OFFSET =
  GUEST_ORDER_AMOUNT_COLUMN_WIDTH + 30;
